export default class AText extends Phaser.GameObjects.BitmapText
{
    /**
     * CONFIG: {width, height}
     * @param {Phaser.Scene} scene 
     * @param {Phaser.GameObjects.Container} parent 
     * @param {object} config 
     */
    constructor(scene, x, y, text, defaultTextSize = 20, config = null, align = 1, font = 'Nasalization')
    {
        super(scene, x, y, font, text, defaultTextSize, align);

        this.config = config;
        this.defaultTextSize = defaultTextSize;

        this.setOrigin(.5);

        if(config != null) this.fitText(this.text);
    }

    setXPos(pos)
    {
        this.x += pos;
    }

    setTextTo(text)
    {
        if(this.config != null) this.fitText(text);
        else this.text = text;
    }

    fitText(text)
    {
        this.fontSize = this.defaultTextSize;
        this.wrap(text);

        if(this.config.height == null) return;

        while(this._bounds.global.height > this.config.height)
        {
            this.fontSize -= 1;
            this.wrap(text);
        }
    }

    wrap(text)
    {
        text = text.replace('\n', ' ');
        let words = text.split(' ');
        let str = "";

        for(let i = 0; i < words.length; i++)
        {
            let word = words[i];
            let prefix = (i == 0) ? '' : ' ';

            str += prefix + word;
            this.text = str;

            let textWidth = this._bounds.global.width;

            if(textWidth >= this.config.width)
            {
                str = str.substring(0, str.lastIndexOf(" ")) + '\n' + word;
            }
        }

        this.text = str;
    }
}